/* eslint-disable import/prefer-default-export */
import { createRoutine } from 'redux-saga-routines';
import {
  LOAD_DOCTOR_DATA,
  LOAD_DOCTOR_LICENSES,
  LOAD_DOCTOR_PRODUCTS,
  LOAD_ORDERS,
  LOAD_ORDERS_TOTAL,
} from './types';

export const loadOrdersDoctorOverview = createRoutine(LOAD_ORDERS);
export const loadDoctorData = createRoutine(LOAD_DOCTOR_DATA);
export const loadDoctorLicences = createRoutine(LOAD_DOCTOR_LICENSES);
export const loadDoctorProducts = createRoutine(LOAD_DOCTOR_PRODUCTS);
export const loadOrdersTotalOverview = createRoutine(LOAD_ORDERS_TOTAL);
